<tx-header
  [editorMeta]="document"
  [isDirty]="isAnswersDirty || isDocumentDirty"
  [initials]="initials"
  [isLoading]="isLoading"
  (onLogout)="logout()"
  (onSave)="save(document)"
  (onPrint)="printDocument(document, 'onHeaderButtonClicked->ActionPrint')"
  (onDownload)="downloadDocument(false)"></tx-header>

<main txDragDropFileUpload (fileDropped)="selectFile($event)">
  <tx-document-editor
    #txTextControlComponent
    width="100%"
    height="100%"
    webSocketURL="{{ websocketUrl }}"
    backColor="#ECECEC"
    statusBarColor="#0c74d5"
    uiCulture="en-US"
    culture="en-US"></tx-document-editor>
</main>

<tx-loader *ngIf="loadingService.loading" [loadingAction]="loadingService.loadingAction"></tx-loader>

<ng-container *ngIf="websocketOpened">
  <tx-form-field-dialog
    [documentDisconnectedFromTXdocsAnswerPool]="documentDisconnectedFromTXdocsAnswerPool"
    [positionEvents]="position$"
    [valueChange]="currentInputValue"
    [isActiveFieldSelected]="isActiveFieldSelected"
    (navigateToNext)="onNavigateToNextFormField($event)"
    (valueChanged)="onFormFieldValueChanged($event.key, $event.value)"
    [fieldNavigatorSidebarVisible]="fieldNavigatorSidebarVisible"
    (dockedChanged)="onDockedChanged($event)"
    (lockAnswerPool)="answerChangedOnSidePanel($event)"></tx-form-field-dialog>

  <ng-container *ngIf="!isFormFieldDocked && fieldNavigatorSidebarVisible">
    <tx-form-field-information-dialog />
  </ng-container>
  <tx-ribbon-clipboard-overlay #clipboardOverlay></tx-ribbon-clipboard-overlay>
  <tx-ribbon-clipboard-paste #clipboardPaste (pasteButtonClicked)="onRibbonPasteButtonClicked($event)"></tx-ribbon-clipboard-paste>
  <tx-txdocs-ribbon-bar
    *ngIf="showTxDocsRibbonBar"
    [isActiveDocument]="document.isActiveDocument"
    [unansweredCount]="unansweredCount"
    (previousClicked)="onPreviousClicked()"
    (nextClicked)="onNextClicked()"
    (showUnansweredOnlyChanged)="onUnansweredValueChanged($event)"
    (searchClicked)="onSearchAnswersClicked($event)"></tx-txdocs-ribbon-bar>

  <button
    type="button"
    class="btn sidebar-close-button"
    (click)="onCloseClickSideBar()"
    title="Close"
    *ngIf="showSideBarCloseButton"
    [disabled]="disableSideBarCloseButton">
    <i class="bi bi-x-lg"></i>
  </button>
  <!-- <div
    id="snippet-marker"
    style="    
      width: 10px;
      height: 10px;
      min-width: 10px;
      min-height: 10px;
      background-color: greenyellow;
      position: absolute;
      top: 10px;
      left: 10px;
      z-index: 99;
    "></div> -->
  <div id="plugContainer">
    <div
      *ngIf="documentDisconnectedFromTXdocsAnswerPool"
      class="div-plug plug-off"
      title="Changes to answers will be saved in the document but will not be saved to the case in TXdocs">
      <div class="icon-container">
        <span class="bar-left"></span>
        <span class="disconnected-text">Disconnected</span>
        <i class="bi bi-plugin"></i>
        <span class="bar-right"></span>
        <!--WiP: styling of disconnected text and strikethrough line-->
      </div>
      <span *ngIf="documentDisconnectedFromTXdocsAnswerPool" class="strikethrough-line"></span>
    </div>
    <div
      *ngIf="!documentDisconnectedFromTXdocsAnswerPool"
      class="div-plug"
      title="Changes to answers will be saved in the document and to the case in TXdocs">
      <div class="icon-container">
        <span class="bar-left"></span>
        <i class="bi bi-plugin"></i>
        <span class="bar-right"></span>
      </div>
    </div>
  </div>
</ng-container>
